import { Alert, Form, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { DirectSaleStockItem } from '@/core/domain/sales/DirectSale/DirectSale.types';
import DirectSaleAddPartForm from '../DirectSaleAddPartForm';
import {
  PartStockPricesResult,
  StockItem,
} from '@/core/domain/stock/StockItems/StockItems.types';
import { usePartStockPrices } from '@/core/domain/stock/StockItems/StockItems.hooks';
import { InvoiceDTO } from '@/core/domain/invoice/invoice/Invoice.types';

type Props = {
  visible: boolean;
  companyId?: number;
  onFinish: (parts: DirectSaleStockItem) => void | Promise<void>;
  directSaleItem?: DirectSaleStockItem;
  handleVisible: () => void;
  partsSelected?: DirectSaleStockItem[];
  invoiceData?: InvoiceDTO[];
};

const DirectSaleAddPartModal = ({
  visible,
  companyId,
  onFinish,
  directSaleItem,
  handleVisible,
  partsSelected,
  invoiceData,
}: Props) => {
  const intl = useIntl();
  const [form] = Form.useForm<DirectSaleStockItem>();
  const [isPartSelected, setPartSelected] = useState(true);
  const [stockPricesItemEdit, setStockPricesItemEdit] =
    useState<PartStockPricesResult>();
  const [loading, setLoading] = useState(false);

  const { data: stockPricesData, dataUpdatedAt } = usePartStockPrices(
    directSaleItem?.partId,
    !!directSaleItem?.partId,
  );

  useEffect(() => {
    if (stockPricesData) {
      setStockPricesItemEdit(
        stockPricesData.result.find((part) => part.company.id === companyId),
      );
    }
  }, [dataUpdatedAt]);

  const handlePartSelect = async (part: StockItem) => {
    if (part) {
      setPartSelected(false);
    }
  };

  useEffect(() => {
    if (directSaleItem) {
      form.setFieldsValue(directSaleItem);

      setPartSelected(false);
    }
  }, [directSaleItem]);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();

      await onFinish({
        ...directSaleItem,
        ...values,
      });

      setPartSelected(true);
      form.resetFields();
      if (directSaleItem) {
        handleVisible();
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setPartSelected(true);
    setStockPricesItemEdit(undefined);
    handleVisible();
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'directSale.modal.title' })}
      open={visible}
      onCancel={handleCancel}
      width={1000}
      onOk={handleSubmit}
      okButtonProps={{ disabled: isPartSelected }}
      confirmLoading={loading}
      destroyOnClose
    >
      <DirectSaleAddPartForm
        isPartSelected={isPartSelected}
        setIsPartSelected={setPartSelected}
        stockPricesItemEdit={stockPricesItemEdit}
        directSaleItem={directSaleItem}
        form={form}
        companyId={companyId}
        partsSelected={partsSelected?.map((item) => item.partId)}
        onPartSelected={handlePartSelect}
      />

      {!!invoiceData?.length && (
        <Alert
          style={{ marginTop: 24 }}
          type="warning"
          message="Atenção!"
          description="
          Você já possui uma nota fiscal gerada para essa venda direta. As alterações feitas não afetarão a nota fiscal, a menos que seja excluída."
        />
      )}
    </Modal>
  );
};
export default DirectSaleAddPartModal;
